import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { getWhdDetails, resetWithholdingRates } from 'actions';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import WithholdingTable from 'components/WithholdingTable';

class WithholdingRates extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    accountWithholdingRates: PropTypes.arrayOf(PropTypes.shape()),
    customerId: PropTypes.string,
    accountId: PropTypes.number,
    isGettingWhd: PropTypes.bool,
    showAccountName: PropTypes.bool
  };

  static defaultProps = {
    permissions: null,
    accountWithholdingRates: null,
    customerId: null,
    accountId: null,
    isGettingWhd: false,
    showAccountName: true
  };

  constructor(props) {
    super(props);
    this.state = {
      accountList: null,
      selectedAccount: null
    };
  }

  componentDidMount() {
    const { accountList } = this.state;
    const { customerId, accountId, dispatch, permissions, accountWithholdingRates } = this.props;
    if ((customerId != null || accountId != null) && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates])) {
      dispatch(getWhdDetails(customerId, accountId));
    }

    if (accountList == null && accountWithholdingRates !== null) {
      this.setAccountList();
    }
  }

  componentDidUpdate() {
    const { accountList } = this.state;
    const { accountWithholdingRates } = this.props;

    if (accountList == null && accountWithholdingRates !== null) {
      this.setAccountList();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    this.setState({ accountList: null });
    dispatch(resetWithholdingRates());
  }

  onAccountValueChanged(e) {
    const { dispatch } = this.props;
    this.setState({ selectedAccount: e.target.value });
    dispatch(getWhdDetails(null, e.target.value));
  }

  setAccountList() {
    const { accountList, selectedAccount } = this.state;
    const { accountWithholdingRates } = this.props;

    if (accountList == null) {
      const listOfAccounts = [];

      for (let i = 0, len = accountWithholdingRates.length; i < len; i += 1) {
        listOfAccounts.push({
          accountName: accountWithholdingRates[i].accountName,
          accountId: accountWithholdingRates[i].accountId,
          accountNumber: accountWithholdingRates[i].accountNumber
        });
      }

      this.setState({ accountList: listOfAccounts });
    }

    if (selectedAccount !== null) {
      this.setState({ selectedAccount: null });
    }
  }

  hasAccountList() {
    const { accountList } = this.state;

    if (accountList == null || accountList.length === 0) {
      return false;
    }

    return true;
  }

  render() {
    const { accountWithholdingRates, isGettingWhd, showAccountName } = this.props;
    const { accountList, selectedAccount } = this.state;
    const withholdingContainer = accountWithholdingRates && accountWithholdingRates.length > 0 && accountWithholdingRates[0];

    function dateFormatter(value, format) {
      return moment(value).format(format);
    }

    function getDateCalculated(withholding) {
      if (withholding && withholding[0] !== null && withholding[0].dateCalculated !== null) {
        return `${ dateFormatter(withholding[0].dateCalculated, 'MMM DD, YYYY') }`;
      }
      return 'N/A';
    }

    return (
      <div>
        <div className="panel-body">
          <table>
            <tbody>
              {showAccountName && <tr>
                <td>
                  <div>
                    <label
                      htmlFor="account_number"
                      className="panel-body-label"
                    >
                      Selected Account:
                    </label>
                  </div>
                </td>
                <td>
                  { this.hasAccountList() && accountList.length > 1
                  && <select
                    id="account-list"
                    name="accountlist"
                    className="form-select"
                    required
                    value={ selectedAccount !== null ? selectedAccount : '' }
                    onChange={ e => this.onAccountValueChanged(e) }
                  >
                    { accountList != null && accountList.map((option, i) => (
                      <option key={ option.accountId } value={ option.accountId }>
                        {option.accountName} -- {option.accountNumber}
                      </option>
                    )) }
                  </select> }
                  { this.hasAccountList() && accountList.length === 1 && <label><span>{accountList[0].accountName} -- {accountList[0].accountNumber}</span></label> }
                  { !this.hasAccountList() && <label>N/A</label> }
                </td>
              </tr>}
              <tr>
                <td>
                  <label
                    htmlFor="calculation_date"
                    className="panel-body-label"
                  >
                    Date Calculated:
                  </label>
                </td>
                <td>
                  <label><span>{ getDateCalculated(accountWithholdingRates) }</span></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          {!isGettingWhd && <WithholdingTable accountWithholding={ withholdingContainer } />}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { auth: {
    permissions
  },
  withholding: {
    accountWithholdingRates,
    isGettingWhd
  } } = state;
  return {
    permissions,
    accountWithholdingRates,
    isGettingWhd
  };
}
const mapDispatchToProps = dispatch => ({ dispatch });
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithholdingRates);
